<template>
  <div class="pr-2">
    <highcharts :options="chartOptions" ref="lineCharts"></highcharts>
    <v-divider></v-divider>
    <div>
      <template>
        <v-row justify="center">
          <v-col cols="2" class="pt-8 pb-8">
            <!-- <v-select
              v-model="filters.type_value"
              :items="list_type"
              outlined
              label="Tipo"
              hide-details="auto"
              :item-text="customText"
              item-value="id"
            ></v-select> -->
          </v-col>
          <v-col
            cols="2"
            class="pt-4"
            v-if="
              filters.type_value != 'diary' &&
                filters.type_value != 'week' &&
                filters.type_value != 'year'
            "
          >
            <v-select
              v-model="filters.year_value"
              :items="list_years"
              outlined
              label="Año"
              hide-details="auto"
            ></v-select>
          </v-col>

          <v-col cols="3" class="pt-4">
            <v-btn color="indigo" dark @click="handleUpdateChart">
              <v-icon size="14" class="mr-1">
                fas fa-redo-alt
              </v-icon>
              Actualizar
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";

import DashboardApi from "../../../apis/Dashboard";
import Tools from "../../../helpers/Tools";
import { generateColor } from "../../../helpers/GenerateColor/generateColor";

export default {
  name: "ProductsChart",
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      dataReport: [],
      categories: [],
      dataValues: [],
      list_years: [],
      list_type: [
        { id: "year", name: "Anual" },
        { id: "biannual", name: "Semestre" },
        { id: "month", name: "Mensual" },
        { id: "week", name: "Semanal" },
        { id: "diary", name: "Diarias" },
      ],
      list_semestre: [
        { id: "Semestre 1 - ", name: "Semestre 1" },
        { id: "Semestre 2 - ", name: "Semestre 2" },
      ],
      list_week: [
        { id: "Semana 1", name: "Semana 1" },
        { id: "Semana 2", name: "Semana 2" },
        { id: "Semana 3", name: "Semana 3" },
        { id: "Semana 4", name: "Semana 4" },
        { id: "Semana 5", name: "Semana 5" },
      ],
      list_diary: [
        { id: "Lunes", name: "Lunes" },
        { id: "Martes", name: "Martes" },
        { id: "Miercoles", name: "Miercoles" },
        { id: "Jueves", name: "Jueves" },
        { id: "Viernes", name: "Viernes" },
        { id: "Sabado", name: "Sabado" },
        { id: "Domingo", name: "Domingo" },
      ],
      list_months: [],
      filters: {
        year_value: this.$moment().year(),
        month_value: this.$moment().month() + 1,
        type_value: "month",
        semestre_value: "Semestre 1 - ",
        week_value: "Semana 1",
        diary_value: "Lunes",
      },
      chartOptions: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
        },

        title: {
          text: "Total de ventas por mes",
        },
        tooltip: {
          pointFormat: "{series.name}: <b> S/ {point.y:.1f}</b>",
        },
        accessibility: {
          point: {
            valueSuffix: "",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.y:.1f}",
            },
          },
        },
        series: [
          {
            name: "",
            colorByPoint: true,
            data: [
              // {
              //   name: "Chrome",
              //   y: 70.67,
              //   sliced: true,
              //   selected: true,
              // },
            ],
          },
        ],
      },
    };
  },
  methods: {
    customText(item) {
      let text = item.name;

      return text;
    },
    getProductionAnalisysPromocional() {
      DashboardApi.getProductionAnalisysPromocional({
        year_value: this.filters.year_value,
        month_value: this.filters.month_value,
        type_value: this.filters.type_value,
      })
        .then((response) => {
          this.dataReport = response.data;
          this.prepareData();
        })
        .catch((error) => {
          console.log("Ocurrió un error");
        });
    },
    prepareData() {
      let value_bar = [];

      this.dataReport.forEach((element, index) => {
        value_bar.push({
          name: element.name,
          color: generateColor(),
          y: Number(element.value),
        });
      });

      this.chartOptions.series[0].data = value_bar;
    },
    getMonthName(number_month) {
      let names = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];

      return names[number_month - 1];
    },
    generateListYears() {
      this.list_years = [];
      let start_year = 2022;
      let end_year = this.$moment().year();
      for (let i = start_year; i <= end_year; i++) {
        this.list_years.push(i);
      }
    },
    handleUpdateChart() {
      let month_name = this.getMonthName(this.filters.month_value);
      this.handleChangeTitle();
      this.getProductionAnalisysPromocional();
    },
    handleChangeTitle() {
      if (this.filters.type_value == "year") {
        this.chartOptions.title.text = "Produccion de Análisis Promocional ";
      } else if (this.filters.type_value == "biannual") {
        this.chartOptions.title.text = `Produccion de Análisis Promocional  del ${this.filters.year_value} `;
      } else if (this.filters.type_value == "month") {
        this.chartOptions.title.text = `Produccion de Análisis Promocional  del ${this.filters.year_value} `;
      } else if (this.filters.type_value == "week") {
        this.chartOptions.title.text = `Produccion de Análisis Promocional  del ${
          this.filters.year_value
        } - ${this.getMonthName(this.filters.month_value)} - ${
          this.filters.week_value
        }`;
      } else if (this.filters.type_value == "diary") {
        this.chartOptions.title.text = `Produccion de Análisis Promocional  - ${this.filters.diary_value}`;
      }
    },
    loadData() {
      this.list_months = Tools.getMonths();
      this.generateListYears();
      let month_name = this.getMonthName(this.filters.month_value);
      this.handleChangeTitle();
      this.getProductionAnalisysPromocional();
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style scoped></style>
